import React, { Fragment } from 'react';
import styledComponents from './styles';
import commonStyles from '../../../../components/DesignPatternV2.0/commonStyles';
import { runtimeConfig } from '../../../../../server/config';

const {
  P_Micro
} = commonStyles;

const {
  Divider,
  StyledCancelSection,
  StyledGhostButtonSmall
} = styledComponents;

export default function CancelSection({ cancelHandler, disabled, translations }) {
  return (
    <Fragment>
      <Divider />
      <StyledCancelSection>
        {runtimeConfig.taxFeatureFlag &&
          <P_Micro>*Tax is estimated and may be adjusted at final invoicing based on current rates in the customer’s service location.</P_Micro>
        }
        <P_Micro>{translations.cancel.description}</P_Micro>
        <StyledGhostButtonSmall onClick={cancelHandler} disabled={disabled} >
          <div className="iconBox">
            <i className="far fa-times" alt="x icon" />
          </div>
          {translations.cancel.button}
        </StyledGhostButtonSmall>
      </StyledCancelSection>
    </Fragment>
  )
}